import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { ProtegoLogo } from '@/components/brand/ProtegoLogo';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Enter your email');
      return;
    }
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email: email.trim() });
      setSent(true);
      toast.success('If that email exists, we sent a reset link');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm">
        <ProtegoLogo size="md" className="mb-8" />
        <h1 className="text-2xl font-semibold mb-1">Reset password</h1>
        <p className="text-sm text-muted-foreground mb-8">
          {sent ? 'Check your inbox for a reset link.' : 'We will email you a link to set a new password.'}
        </p>
        {!sent && (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                className="h-11"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 grad-accent text-white border-0">
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}
        <p className="text-center text-sm text-muted-foreground mt-6">
          <Link to="/login" className="text-[hsl(188,100%,55%)] hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
